<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Tipos de Pontos de Venda</h1>
        <paragrafo
          >Nesta opção serão incluídos os tipos de Pontos de Venda.</paragrafo
        >
        <imagem :src="image_2" />
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "TiposPontosVenda",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    // negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_2: "/imagensAdmin/Pessoas/pessoas2.png",
    };
  },
};
</script>
